import { render } from "./ReplyForm.vue?vue&type=template&id=19c08c63"
import script from "./ReplyForm.vue?vue&type=script&lang=js"
export * from "./ReplyForm.vue?vue&type=script&lang=js"

import "./ReplyForm.vue?vue&type=style&index=0&id=19c08c63&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__